/* eslint-disable no-underscore-dangle, react/prop-types, react/no-danger, no-return-assign */
import classnames from 'classnames';
import React from 'react';
import { decode } from 'html-entities';
import { format, parseISO } from 'date-fns';
import { Link } from 'react-router-dom';
import FeaturedImage from './FeaturedImage';

const Featured = ({ hasGrid, path, post }) => {
  // Retrieve categories
  const categories = post._embedded['wp:term'].find(
    (group) => group.length && group[0].taxonomy === 'category',
  );
  // Retrieve featured media
  const media = post?._embedded?.['wp:featuredmedia']?.[0];
  // Retrieve the authors
  const authors = post.authors_expanded;
  const published = format(parseISO(post.date), 'M/d/yyyy');
  return (
    <div
      className={classnames({
        'featured-post': true,
        'only-post': !hasGrid,
      })}
    >
      <div className="left">
        <div className="categories">
          {categories.map((category) => {
            const qs = `category=${category.id}`;
            return (
              <Link key={category.id} to={`${path}?${qs}`}>
                {category.name}
              </Link>
            );
          })}
        </div>
        <h2><a href={post.link}>{decode(post?.title?.rendered)}</a></h2>
        <div className="excerpt" dangerouslySetInnerHTML={{ __html: post?.clean_excerpt }} />
        <div className="meta">
          {authors && authors.map(a => (
            <div key={`author-${a.id}`}>
              <Link to={`${path}?by=${a?.id}`}>{a?.name}</Link>
            </div>
          ))}
          <span>Published {published}</span>
        </div>
        <div className="read-more">
          <a href={post.link}>
            Read More
          </a>
        </div>
      </div>
      <div className="right">
        {post?.video_embed ? (
          <div className="responsive-video">
            <div dangerouslySetInnerHTML={{ __html: post.video_embed }} />
          </div>
        ) : (
          media?.media_type === 'image' && <FeaturedImage image={media} link={post.link} />
        )}
      </div>
    </div>
  );
};

export default Featured;
